import { MutationUpdaterFn } from '@apollo/client'
import {
  DeleteNotificationMutation,
  GqlNotificationListDocument,
  GqlNotificationListQuery,
  GqlNotificationListQueryVariables,
} from 'generated/graphql'

const deleteNotificationUpdater =
  (
    variables: GqlNotificationListQueryVariables,
  ): MutationUpdaterFn<DeleteNotificationMutation> =>
  (cache, mutationResult) => {
    // delete data
    const cachedNotifications = cache.readQuery<GqlNotificationListQuery>({
      query: GqlNotificationListDocument,
      variables: variables,
    })

    // get deleted notification
    if (
      !mutationResult.data ||
      !mutationResult.data.deleteNotification.notification
    )
      return
    const deletedNotification =
      mutationResult.data.deleteNotification.notification

    if (!cachedNotifications || !cachedNotifications.viewerNotifications) return

    cache.writeQuery({
      query: GqlNotificationListDocument,
      variables: variables,
      data: {
        ...cachedNotifications,
        viewerNotifications: {
          ...cachedNotifications.viewerNotifications,
          nodes: cachedNotifications.viewerNotifications.nodes.filter(
            (notification) => notification?.id !== deletedNotification.id,
          ),
        },
      },
    })

    // count data
    // refetchScreen()
  }

export default deleteNotificationUpdater
